<svg [attr.height]="size" [attr.width]="size" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  <path
    [attr.stroke]="color"
    d="M3.5 7V17C3.5 20 4.97 22 8.5 22H15.5C18.97 22 20.5 20 20.5 17V15.83C20.5 15.3 20.29 14.79 19.91 14.42L19.08 13.59C18.7 13.21 18.49 12.71 18.49 12.18V10C18.49 9.45 18.94 9 19.49 9C20.04 9 20.49 8.55 20.49 8V7C20.49 4 18.96 2 15.49 2H8.49C4.97 2 3.5 4 3.5 7Z"
    stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
  <path
    [attr.stroke]="color"
    d="M7.98998 21.97L7.97998 19C7.97998 17.89 8.86998 17 9.97998 17H13.99C15.09 17 15.98 17.89 15.99 18.99L16.02 21.98"
    stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
  <path [attr.stroke]="color" d="M8.93994 4.94957L8.98994 2.05957" stroke-linecap="round" stroke-linejoin="round"
        stroke-width="1.5"/>
  <path [attr.stroke]="color" d="M11.9399 4.94957L11.9899 2.05957" stroke-linecap="round" stroke-linejoin="round"
        stroke-width="1.5"/>
  <path [attr.stroke]="color" d="M14.9399 4.92004L14.9899 2.04004" stroke-linecap="round" stroke-linejoin="round"
        stroke-width="1.5"/>
</svg>
